import { useState, useCallback, useImperativeHandle, forwardRef } from 'react';
import VenueListItem from './ListItem';
import MaintenanceModal from './MaintenanceModal';
import { getListService } from '../../API/ServiceAPI';
import InfiniteScroll from 'react-infinite-scroller';

const VenueList = forwardRef((props, ref) => {
  const [venues, setVenues] = useState([]);
  const [nextPage, setNextPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);
  const [selectedVenue, setSelectedVenue] = useState(null);

  useImperativeHandle(ref, () => ({
    onClickSportType: () => {
      setVenues([]);
      setNextPage(1);
      setLoading(false);
    },
    refreshData: () => {
      setVenues([]);
      setNextPage(1);
      setLoading(false);
    }
  }));

  const loadServices = useCallback(
    async () => {
      if (loading) {
        return;
      }

      setLoading(true);

      const onSuccessHandler = (responseJSON) => {
        setVenues([...venues, ...responseJSON.venues]);

        if (responseJSON.pagination.next_page !== "") {
          setNextPage(responseJSON.pagination.next_page);
        } else {
          setNextPage(null);
        }
      }
      const onFailureHandler = (messages) => console.debug("FAIL", messages);
      getListService(props.search, props.sportType, props.sortBy, props.sortDirection, nextPage, onSuccessHandler, onFailureHandler);

      setLoading(false);
    }, [venues, loading, nextPage]
  )

  const hasMoreItems = !!nextPage;

  const handleVenueClick = (venue) => {
    setSelectedVenue(venue);
    setShowMaintenanceModal(true);
  };

  const handleCloseModal = () => {
    setShowMaintenanceModal(false);
    setSelectedVenue(null);
  };

  const loader = (
    <div key="loader" className="loader">
      Loading ...
    </div>
  );

  return (
    <div>
      <InfiniteScroll loadMore={loadServices} hasMore={hasMoreItems} loader={loader}>
        <div className='flex flex-1 flex-col my-4 gap-y-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4'>
          {venues.filter(venue =>
            venue.id === 5
          ).map((venue) => <VenueListItem key={venue.id} data={venue} onClick={handleVenueClick} />)}
        </div>
      </InfiniteScroll>

      <MaintenanceModal
        isOpen={showMaintenanceModal}
        onClose={handleCloseModal}
      />
    </div>
  )
})

export default VenueList;